import FilterBoolean from './filterBoolean'

export default FilterBoolean
